import React from 'react';
import projects from '../../api/projects.json'; 

const Portfolio = () => {
    return (
        <div className="portfolio-page text-light p-5">
            <div className="row row-cols-1 row-cols-md-3 g-4">
                {projects.map((project, index) => (
                    <div key={index} className="col">
                        <div className="project-card p-4 h-100">
                            {/* Project Title */}
                            <h3 className="fs-6">{project.title}</h3>

                            {/* Links */}
                            <div className="d-flex gap-3 mt-3">
                                {project.github && (
                                    <a
                                        href={project.github}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-accent text-decoration-none"
                                    >
                                        <i className="bi bi-github"></i> GitHub
                                    </a>
                                )}
                                {project.demo && (
                                    <a
                                        href={project.demo}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-accent text-decoration-none"
                                    >
                                        <i className="bi bi-box-arrow-up-right"></i> Demo
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Portfolio;
